import React, { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { toggleMeetingHostControlsActive } from 'flow/actions/meeting-actions';
import { selectShouldShowHostControlsPanel } from 'flow/selectors/meeting-selectors';
import Icon from 'flow/components/ui-components/Icon';
import MenuItem from 'flow/components/ui-components/MenuItem';

// The headless menu closes itself when an item is activated, so items only
// need to fire their action.
const MenuItemToggleHostControls = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const shouldShow = useAppSelector(selectShouldShowHostControlsPanel);

    const onClick = useCallback(() => {
        dispatch(toggleMeetingHostControlsActive());
    }, [dispatch]);

    if (!shouldShow) return null;

    return (
        <MenuItem
            onClick={onClick}
            className="!bg-gray-800 !text-white hover:!bg-gray-700"
        >
            <Icon iconKey="adminPanelSettingsOutlined" className="me-1.5" />
            <div>{i18next.t('videoconference.host_controls.title')}</div>
        </MenuItem>
    );
};

export default MenuItemToggleHostControls;
